import React from "react";
import PortfolioSite from "./Portfolio";

function App() {
  return <PortfolioSite />;
}

export default App;
